  import { createIcon } from '@chakra-ui/react'
  const OrganizeIcon = createIcon({
    // The displayName is useful for debugging in React DevTools
    displayName: 'OrganizeIcon',

    // The viewBox of our original SVG
    viewBox: '0 0 24 24',

    path: [
      <path
        key="1" // Unique key for the first path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 2.5 L21 7.5 L21 17.5 L12 22.5 L3 17.5 L3 7.5 Z"
      />,
      <path
        key="2" // Unique key for the second path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        // This is the <path> equivalent of <circle cx="12" cy="12" r="4" />
        d="M16 12 A4 4 0 1 1 8 12 A4 4 0 0 1 16 12 Z"
      />,
    ],
  })

  export default OrganizeIcon